/**
 * Gate du mode tablette (parité legacy C10 — accès protégé).
 * Le legacy ouvrait la tablette via `?tablet=1` (peu sûr). Ici : si le tenant a
 * un `tablet_pin` configuré, l'écran tablette demande ce PIN une fois, puis
 * mémorise l'accès (localStorage). Si aucun PIN n'est configuré → accès libre
 * (rétro-compatible, ne casse pas l'usage actuel). Logique PURE et testable.
 */

/** Le gate est-il requis ? (uniquement si un PIN non vide est configuré.) */
export function gateRequired(pin: string | null | undefined): boolean {
  return Boolean(pin && pin.trim().length > 0);
}

/** Le PIN saisi correspond-il ? (comparaison trim, insensible aux espaces de bord.) */
export function checkPin(input: string, pin: string | null | undefined): boolean {
  if (!gateRequired(pin)) return true;
  return input.trim() === (pin ?? '').trim();
}

/** Clé localStorage de l'accès tablette d'un tenant. */
export function gateStorageKey(tenantId: string): string {
  return `lilco_tablet_ok_${tenantId}`;
}
